import {DeadlineFilterItemType, DeadlineSearchParamType} from "../interface";
import {Control, UseFormRegister} from "react-hook-form";
import InputNumberUc from "../../../../../components/common/number/InputNumberUc";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    watchSearchParam: DeadlineSearchParamType
    register: UseFormRegister<DeadlineSearchParamType>
    watchFilterItem: DeadlineFilterItemType
    registerFilter: UseFormRegister<DeadlineFilterItemType>
    btnSearch: () => any
    btnSaveTaxEndDate: () => any
    btnApplyExchangeRate: () => any
    controlFilter: Control<DeadlineFilterItemType>
}

export default function Filter({
                                   watchSearchParam,
                                   register,
                                   watchFilterItem,
                                   registerFilter,
                                   btnSearch,
                                   btnSaveTaxEndDate,
                                   btnApplyExchangeRate,
                                   controlFilter
                               }: PropsType) {

    return <div className="fiter_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">마감 검색</h3>
            <div className="filter_toolbar"></div>
        </div>

        <div className="row">
            <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">상태</label>
                    <select className="form-select me-0"
                            value={watchSearchParam.endFlag}
                            {...register("endFlag")}>
                        <option value={"0"}>전체</option>
                        <option value={"Y"}>마감</option>
                        <option value={"N"}>미 마감</option>
                    </select>
                    {/*<button className="btn btn-info btn_search">*/}
                    {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회*/}
                    {/*</button>*/}
                </div>
                <AuthorityChecker authorityNames={['endWriteYn']}>
                    <div className="frm_row search justify-content-start">
                        <label htmlFor="" className="form-label frm_label">세금계산서 마감일</label>
                        <input type="date" className="form-control w-150px"
                               value={watchFilterItem.taxEndDate}
                               {...registerFilter("taxEndDate")}/>
                        <button className="btn btn-info btn_search" onClick={btnSaveTaxEndDate}>저장</button>
                    </div>
                </AuthorityChecker>
            </div>

            <div className="col-6">
                <div className="frm_row">
                    <label htmlFor="" className="form-label frm_label">수주일자</label>
                    <div className="frm_field input_date">
                        <input type="date"
                               className="form-control"
                               value={watchSearchParam.fromDate}
                               {...register("fromDate")}/>
                        <span className="txt_range">~</span>
                        <input type="date"
                               className="form-control me-0"
                               value={watchSearchParam.toDate}
                               {...register("toDate")}/>
                        <button className="btn btn-info btn_search" onClick={btnSearch}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                        </button>
                    </div>
                </div>

                {/*<div className="frm_row">*/}
                {/*    <label htmlFor="" className="form-label frm_label">환율 일괄 적용</label>*/}
                {/*    <div className="frm_field">*/}
                {/*        <div className="form-check form-check-inline">*/}
                {/*            <input className="form-check-input"*/}
                {/*                   type="radio"*/}
                {/*                   id="inlineRadio1"*/}
                {/*                   checked={watchFilterItem.rateFlag === "1"}*/}
                {/*                   value={"1"}*/}
                {/*                   {...registerFilter("rateFlag")}/>*/}
                {/*            <label className="form-check-label" htmlFor="inlineRadio1">전월 평균</label>*/}
                {/*        </div>*/}
                {/*        <div className="form-check form-check-inline">*/}
                {/*            <input className="form-check-input"*/}
                {/*                   type="radio"*/}
                {/*                   id="inlineRadio2"*/}
                {/*                   checked={watchFilterItem.rateFlag === "2"}*/}
                {/*                   value={"2"}*/}
                {/*                   {...registerFilter("rateFlag")}/>*/}
                {/*            <label className="form-check-label" htmlFor="inlineRadio2">기간 평균</label>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className="frm_row">*/}
                {/*    <label htmlFor="" className="form-label frm_label"></label>*/}
                {/*    <div className="frm_field input_date">*/}
                {/*        <input type="date"*/}
                {/*               className="form-control"*/}
                {/*               value={watchFilterItem.rateFromDate}*/}
                {/*               {...registerFilter("rateFromDate")}/>*/}
                {/*        <span className="txt_range">~</span>*/}
                {/*        <input type="date"*/}
                {/*               className="form-control"*/}
                {/*               value={watchFilterItem.rateToDate}*/}
                {/*               {...registerFilter("rateToDate")}/>*/}
                {/*        <input type="text"*/}
                {/*               className="form-control me-0"*/}
                {/*               value={watchFilterItem.newDExchangeRate}*/}
                {/*               {...registerFilter("newDExchangeRate")}/>*/}
                {/*        <button className="btn btn-info btn_search w-80px" onClick={btnApplyExchangeRate}>적용</button>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <AuthorityChecker authorityNames={['endWriteYn']}>
                    <div className="frm_row search justify-content-start">
                        <label htmlFor="" className="form-label frm_label">환율 일괄 적용</label>
                        <InputNumberUc name={"newDExchangeRate"} control={controlFilter}/>
                        {/*<input type="text"
                           className="form-control me-0 w-150px"
                           value={watchFilterItem.newDExchangeRate}
                           {...registerFilter("newDExchangeRate")}/>*/}
                        <button className="btn btn-info btn_search w-80px" onClick={btnApplyExchangeRate}>적용</button>
                    </div>
                </AuthorityChecker>
            </div>
        </div>
    </div>
}